import {h, Component} from 'preact'
import {connect} from 'react-redux'

import reduce from '../reducers';
import * as actions from '../actions';

export default @connect(reduce, actions)
class Keys extends Component {
    render (props, state) {
        return (
            <div style="width: 100%; text-align: center;">
                <div class="lds2-ellipsis"><div></div><div></div><div></div><div></div></div>
            </div>
        )
    }
}
